import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.InviteUsersPopupContent', {
    title: `{count, plural, one {Invite user} other {Invite users}}`,
    inviteUsersButtonTitle: `{count, plural, one {Invite user to the Organisation} other {Invite users to the Organisation}}`,
    commentTitle: 'Message to user',
    commentPlaceholder: 'Enter your message here (optional)...',
    inviteUsersButtonText: 'Invite now',
    descriptionNoInviteMessage:
        '{users} will be invited by email to join the Organisation "{companyName}" in ApprovalMax.',
    description:
        '{users} will be invited by email to join the Organisation "{companyName}" in ApprovalMax.{br}' +
        'You can add an invitation message; it will be displayed in the email. This is optional.',

    users: ' and {count} others',
});
